import { createContext, useContext, useMemo, useState, useCallback } from 'react';

const QuoteCartContext = createContext(null);

export function QuoteCartProvider({ children }) {
  const [items, setItems] = useState([]); // {id, sku, name}
  const [open, setOpen] = useState(false);

  const add = useCallback((product) => {
    setItems(prev => prev.find(p => p.id === product.id) ? prev : [...prev, product]);
  }, []);
  const remove = useCallback((id) => setItems(prev => prev.filter(p => p.id !== id)), []);
  const clear = useCallback(() => setItems([]), []);

  const value = useMemo(
    () => ({ items, add, remove, clear, open, setOpen }),
    [items, add, remove, clear, open]
  );

  return (
    <QuoteCartContext.Provider value={value}>
      {children}
    </QuoteCartContext.Provider>
  );
}

export const useQuoteCart = () => useContext(QuoteCartContext);
